import React from "react";
import {usePaymentTypesData} from "../../../hooks/usePaymentTypesData";
import {useDispatch, useSelector} from "react-redux";
import {getDataFresh, getPaymentTypesData} from "../../../state/selectors";
import LoadingSpinner from "../../Utils/Spinner";
import { Box, Column, Columns, Table, Title } from "@allxsmith/bestax-bulma";
import PaymentTypeRow from "./PaymentTypeRow";
import CreatePaymentType from "./CreatePaymentType";
import {createSetDataFreshAction, createSetPaymentTypesDataAction} from "../../../actions/dataActions";
import {ToastContainer, toast} from "react-toastify";
import axios from "axios";

export default function PaymentTypeView(props){
    const dataFresh = useSelector(getDataFresh);
    const dispatch = useDispatch();
    let loaded = usePaymentTypesData({}, dataFresh)
    const data = useSelector(getPaymentTypesData);

    if(!loaded){
        return (<LoadingSpinner/>);
    }
    const onSave = (data) => {
        let url = props.endpoint+"paymenttype";
        if(data.id){
            url = url+"/"+data.id
        }
        const conf = {
            url: url,
            method: data.id ? "put" : "post",
            data
        }
        axios(conf).then(() => {
            dispatch(createSetDataFreshAction(dataFresh + 1));
        }).catch(err => {
            toast.error("There was an error saving payment type", {position: "top-right"});
        })
    }
    const onDelete = (data) => {
        const conf ={
            url: props.endpoint+"paymenttype/"+data.id,
            method: "delete"
        }
        axios(conf).then(() => {
            dispatch(createSetDataFreshAction(dataFresh + 1));
        }).catch(err => {
            toast.error("There was an error deleting a payment type", {position: "top-right"});
        })
    }
    const handleChange = (e, index) => {
       let newResults = [...data.results];
       let newTypes = {...data, results: newResults};
       let newType = {...data.results[index]};
       newType[e.target.name] = e.target.value;
       newTypes.results[index] = newType
       dispatch(createSetPaymentTypesDataAction(newTypes));
    }
    return (
        <div>
            <br/>
            <CreatePaymentType onSave={onSave}/>
            <Box>
                <details>
                    <summary><Title>Payment Type</Title></summary>
                    <Columns isMultiline>
                        <Column>
                            <Table
                                isFullwidth
                            >
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                {data.results.map((type,index) => (
                                    <PaymentTypeRow
                                        index={index}
                                        data={type}
                                        dataFresh={dataFresh}
                                        handleChange={handleChange}
                                        onSave={onSave}
                                        onDelete={onDelete}
                                    />
                                ))}
                                </tbody>
                            </Table>
                        </Column>
                        <Column/>
                        <Column/>
                        <Column/>
                    </Columns>
                </details>
            </Box>
        </div>
    );


}